import React, { FC } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';

type Props = {
  stripePromise: any;
  // Base invoice total (before card fee) and the details needed to create the
  // PaymentIntent once the card country is known (EA-1344).
  amount: number;
  permitId: number | string;
  invoiceNumber: string;
  email: string;
  onCancel?: () => void;
};

const StripeElements: FC<Props> = ({ stripePromise, amount, permitId, invoiceNumber, email, onCancel }) => {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm
        onCancel={onCancel}
        amount={amount}
        permitId={permitId}
        invoiceNumber={invoiceNumber}
        email={email}
      />
    </Elements>
  );
};

export default StripeElements;
